import React, { Component } from 'react'
import { FormDeveloper } from 'scorpion-core'
import { Button } from '@material-ui/core'
import ConvidarPerfil from '../../../../admin/ConsultaPerfisAdmin/componentes/ConvidarPerfil';
import { doSignOut } from '../../../../../firebase/auth';

import { apiSalveInColection, apiDeleteInColection, apiSyncReducer } from 'scorpion-core';
import { prodConfig1 } from '../../../../../ConfigAplication'
import firebase from 'firebase/app';

var secondaryApp = firebase.initializeApp(prodConfig1, "Secondary3");
export default class CriarCustomForm extends Component {
    constructor(props) {
        super(props)
        this.copiarParaOkProjects = this.copiarParaOkProjects.bind("this")
        this.state = { txtComp:"" }
    }
    componentDidMount() {
        this.props.listarPerfis();
    }

    copiarParaOkProjects(value) {
        console.log("copiarParaOkProjects", value);
        const firestore = secondaryApp.firestore();
        const settings = {/* your settings... */ timestampsInSnapshots: true };
        firestore.settings(settings);
        let cols = firestore.collection("CustomForm");
        console.log("cols", cols);

        apiSalveInColection(cols, value)

    }
    render() {

        let metasAdd = [<ConvidarPerfil key={"userEditar"} label="Users Editar" />,
        <ConvidarPerfil key={"userVer"} label="Users Preenxer" name={"viewers"} />,
        <Button key={"tudo"} onClick={() => console.log("mmmm", JSON.stringify(this.props.atualValues.componenteRoot))}>StrComponentes</Button>,
      
        ]
        return (
            <div>
                <FormDeveloper {...this.props} metasAdd={metasAdd} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/components/CriarCustomForm/CriarCustomForm.js